import { camelizeKeys } from 'humps';
import { post } from '@namespace/helpers';

export const getAllTypesBonusesHistory = async ({ pagination }) =>
  post('/service/bff/v1/bonuses/history/get', {
    pagination
  }).then(({ error_code: errorCode, data }) =>
    errorCode ? Promise.reject(errorCode) : camelizeKeys(data)
  );
